<template>
  <v-layout>
    <span :style="{color: getEventColor('ChangeRequested')}">
      <v-tooltip bottom>
        <span slot="activator">
          {{requestedQuantity}}
        </span>
        Requested quantity allTime
      </v-tooltip>

      <v-tooltip bottom v-if="showRequestedInPeriod">
        <span slot="activator">
          ({{requestedQuantityInPeriod}})
        </span>
        Requested quantity inPeriod
      </v-tooltip>
    </span>

    <span :style="{color: getEventColor('ChangeExecuted'), marginLeft: '1em'}">
      <v-tooltip bottom>
        <span slot="activator">
          {{executedQuantity}}
        </span>
        Executed quantity allTime
      </v-tooltip>

      <v-tooltip bottom v-if="showExecutedInPeriod">
        <span slot="activator">
          ({{executedQuantityInPeriod}})
        </span>
        Executed quantity inPeriod
      </v-tooltip>
    </span>
  </v-layout>
</template>

<script>
  import {getEventColor} from '../Sales/case/caseServiceLogUtils'
  import DevMode from "../Ui/DevMode";

  export default {
    name: 'service-quantity-info',
    components: {DevMode},
    props: {
      requestedQuantity: {
        type: Number,
        required: true
      },
      requestedQuantityInPeriod: {
        type: Number,
        default: null
      },
      executedQuantity: {
        type: Number,
        required: true
      },
      executedQuantityInPeriod: {
        type: Number,
        default: null
      }
    },
    data() {
      return {}
    },
    computed: {
      showRequestedInPeriod() {
        return this.requestedQuantityInPeriod !== null && this.requestedQuantity !== this.requestedQuantityInPeriod
      },
      showExecutedInPeriod() {
        return this.executedQuantityInPeriod !== null && this.executedQuantity !== this.executedQuantityInPeriod
      }
    },
    methods: {
      getEventColor(event) {
        return getEventColor(event)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/ServiceQuantityInfo.vue